<template>
  <v-app>
    <navigation-drawer v-if="$route.path !== '/login' && drawer"/>
    <app-bar v-if="$route.path !== '/login'"/>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
        <v-snackbar
            :value="showAlert"
            :timeout="alertDuration"
            dark
            :color="alertType === 'success' ? 'success' : 'red'"
        >
          {{ alertMessage }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from './components/NavigationDrawer'
import AppBar from "./components/AppBar";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'App',
  computed: {
    ...mapState('app', ['showAlert', 'alertMessage', 'alertDuration', 'alertType', 'drawer']),
    ...mapGetters('auth', ['loggedIn'])
  },
  mounted(){
    if (this.loggedIn) {
      this.fetchAppSettings()
    }
  },
  components: {
    NavigationDrawer, AppBar
  },
  methods:{
    ...mapActions('app', ['fetchAppSettings'])
  }
};
</script>
